module.exports = "../static/media/icon_copy.2eb2fc8a.png";